import LanguageModel from "./LanguageModel";
import LocalStorageCollection from "../prototypes/LocalStorageCollection";

class LanguageCollection extends LocalStorageCollection<LanguageModel> {
  name = "LanguageCollection";
  route = "apiLanguageCollection";
  initialize(
    models?: Record<string, any>[] | LanguageModel[],
    options?: any
  ): void {
    const collection = this;
    super.initialize.apply(collection, [models, options]);
  }
}
LanguageCollection.prototype.model = LanguageModel;
// LanguageCollection.prototype.url = () => "/sushimessage/";
export default LanguageCollection;
